import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  PAGES_PROGRESS,
  PAGES_SUCCESS,
  PAGES_FAILED,
  PAGES_GET_LIST_PROGRESS,
  PAGES_GET_LIST_SUCCESS,
  PAGES_GET_LIST_FAILED,
  PAGES_FORM_SUBMIT_PROGRESS,
  PAGES_FORM_SUBMIT_SUCCESS,
  PAGES_FORM_SUBMIT_FAILED,
  PAGES_GET_PAGE_PROGRESS,
  PAGES_GET_PAGE_SUCCESS,
  PAGES_GET_PAGE_FAILED,
  PAGES_CLEAR_STATE,
  PAGES_CLEAR_FLASH_MESSAGE,
} from '../actions/pagesAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PAGES_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: PAGES_PROGRESS },
      });
    }
    case PAGES_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: PAGES_SUCCESS },
      });
    }
    case PAGES_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: PAGES_FAILED },
      });
    }
    case PAGES_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: PAGES_PROGRESS } });
    }
    case PAGES_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: PAGES_SUCCESS },
      });
    }
    case PAGES_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: PAGES_FAILED } });
    }
    case PAGES_GET_PAGE_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: PAGES_PROGRESS },
      });
    }
    case PAGES_GET_PAGE_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.page },
        loadActiveStatus: { $set: PAGES_SUCCESS },
      });
    }
    case PAGES_GET_PAGE_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: PAGES_FAILED },
      });
    }
    case PAGES_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case PAGES_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
